import { render, staticRenderFns } from "./BusinessContactCompanyForm.vue?vue&type=template&id=3106f4be"
import script from "./BusinessContactCompanyForm.vue?vue&type=script&lang=js"
export * from "./BusinessContactCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports